import { useRouter } from 'next/router';

export const useSpecialOffer = () => {
  const router = useRouter();

  return {
    isSpecialOffer: router.pathname === '/special-offer',
  };
};
